export default __webpack_public_path__ + "static/media/lingerie-1.d7bb875f.jpg";